/**
 * PostItemStats - Re-sphere, comments, optional share. Aura shown inline on tags via AuraPill.
 */

import React from 'react';
import NavIcon from '../Layout/NavIcon';

function PostItemStats({
  post,
  onCommentsClick,
  onResphereClick,
  onShareClick,
  resphereBusy = false,
  resphereCount: resphereCountOverride,
  userHasResphered: userHasRespheredOverride,
}) {
  const commentsCount = post.comments_count ?? 0;
  const resphereCount = resphereCountOverride ?? post.resphere_count ?? 0;
  const userHasResphered = userHasRespheredOverride ?? post.user_has_resphered ?? false;

  return (
    <div className="flex gap-6 items-center text-sm">
      <button
        type="button"
        onClick={onResphereClick}
        disabled={resphereBusy || !onResphereClick}
        aria-label={
          userHasResphered
            ? `Remove re-sphere, ${resphereCount}`
            : `Re-sphere, ${resphereCount}`
        }
        aria-pressed={userHasResphered}
        data-testid="post-resphere-button"
        className={`flex items-center gap-1 transition-colors disabled:opacity-50 ${
          userHasResphered ? 'text-ether' : 'text-silver hover:text-ether'
        }`}
      >
        <NavIcon icon="resphere" className="w-4 h-4" />
        <span>{resphereCount}</span>
      </button>
      <button
        type="button"
        onClick={onCommentsClick}
        aria-label={`Comments, ${commentsCount}`}
        className="flex items-center gap-1 text-silver hover:text-ether transition-colors"
      >
        <NavIcon icon="comments" className="w-4 h-4" />
        <span>{commentsCount}</span>
      </button>
      {onShareClick ? (
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            onShareClick(e);
          }}
          aria-label="Copy link to post"
          data-testid="post-share-button"
          className="flex items-center justify-center text-silver hover:text-ether transition-colors"
        >
          <NavIcon icon="share" className="w-4 h-4" />
        </button>
      ) : null}
    </div>
  );
}

export default PostItemStats;
